import React from 'react'
import IssueNavigation from '../components/issue_navigation.js'

class Issue extends React.Component {
  constructor() {
    super()
  }

  render () {
    const issue_data = this.props.data.themenJson;

    return (
      <div className="issue">
        <div className="sideBarLeft">
          <div className="cover">
            <a href={`/issue/${issue_data.issue_date}`}>cover</a>
          </div>
          <div className="sections">
            <IssueNavigation issue_data={issue_data} />
          </div>
          <div className="impressum">
            <ul>
              <li><a href={`/about/`}>about</a></li>
              <li><a href={`/editorial/`}>editorial</a></li>
              <li><a href={`/contact/`}>contact</a></li>
            </ul>
          </div>
          <div className="archive">
            <a href="/archive/">archive</a>
          </div>
        </div>
        <div className="artwork">
          <img src={`/media/covers/${issue_data.thema_cover_uri}`} />
        </div>
        <div className="nav-and-metadata">
        </div>
      </div>
    );
  }
}

export default Issue

export const query = graphql`
  query ThemaQuery($id: String!) {
      # Select the issue whose id matches this page's id.
      themenJson(id: {
          eq: $id
      }) {
        id
        thema
        thema_cover_uri
        jahr
        monat
        monat_num
        issue_date
        moving_image_count
        still_image_count
        textz_count
        soundz_count
      }
  }
`


// WEBPACK FOOTER //
// ./src/templates/issue.js